<img class="img-background" src="../../../../../assets/img/background-pages.jpg" alt="Background" />
<!-- Header Negro TIX -->
<header class="bg-black p-0 text-center z-2 position-fixed w-100 top-0">
  <img src="assets/img/logo-tix.png" width="60px" alt="" />
</header>

<main class="py-4 py-md-5" style="margin-top: 60px">
  <div class="container" style="max-width: 896px">
    <!-- Success Message -->
    <div class="text-center mb-4">
      <div class="success-circle mx-auto mb-3">
        <span class="material-symbols-outlined success-icon">check_circle</span>
      </div>
      <h1 class="h4 text-dark mb-3 d-flex gap-2 align-items-center justify-content-center">
        ¡Orden <strong>TIX-{{ order?.id ?? '' }}</strong> Confirmada!
        <img src="assets/img/emojis/party-popper.svg" alt="party emoji" loading="lazy" width="26" />
      </h1>
      <p class="text-muted mx-auto" style="max-width: 28rem">
        ¡Gracias por tu compra! Tus entradas han sido enviadas a
        <span class="text-black fw-semibold">{{
          order?.buyerEmail ?? ''
          }}</span>
      </p>
    </div>

    <!-- Action Buttons -->
    <div class="row g-3 mb-4 buttons-container">
      <div class="col-12 d-flex flex-column gap-2" [ngClass]="{
          'col-md-8': calendarEvent && isWalletVisible,
          'col-md-12':
            (calendarEvent && !isWalletVisible) ||
            (!calendarEvent && isWalletVisible)
        }">
        <a class="btn-custom-dark w-100 rounded-pill d-flex align-items-center justify-content-center gap-2 text-decoration-none"
          [target]="'_blank'" routerLink="/order/{{ order?.slug }}/details" [class.disabled]="!order?.slug"
          style="padding: 6px 0px; background-color: #000000">
          <span style="height: 18px; display: flex; align-items: center"><img src="assets/img/emojis/ticket.svg"
              alt="ticket" loading="lazy" width="26" />
          </span>
          <span class="fw-medium">Ver Tickets</span>
        </a>
      </div>

      <!-- <div
        *ngIf="calendarEvent"
        class="col-12"
        [ngClass]="{
          'col-md-4': isWalletVisible,
          'col-md-6': !isWalletVisible
        }"
      >
        <app-add-to-calendars [event]="calendarEvent"></app-add-to-calendars>
      </div> -->

      <div class="col-12" [ngClass]="{
          'col-md-8': calendarEvent && isWalletVisible,
          'col-md-12': !calendarEvent && isWalletVisible
        }">
        <app-wallet-passes *ngIf="canAddToWallet" [slug]="order!.slug"
          (visibilityChange)="onWalletVisibilityChange($event)"></app-wallet-passes>
      </div>
    </div>

    <!-- Event Card -->
    <div class="card card-glass border-1 mb-4" style="border-color: #0000001a">
      <div class="row g-0">
        <div class="col-md-auto">
          <img [src]="getImageUrl()" alt="Event" class="event-image" />
        </div>
        <div class="col-md">
          <div class="p-4 d-flex flex-column gap-2">
            <h2 class="h4 fw-bold text-dark">
              {{ eventName ? eventName : 'TIX Event' }}
            </h2>

            <div class="d-flex flex-column gap-2" *ngFor="let date of dates">
              <div class="d-flex align-items-start gap-3">
                <span class="fs-5"><img src="assets/img/emojis/calendar.svg" alt="calendar" loading="lazy"
                    width="20" /></span>
                <p class="mb-0 text-dark" style="text-transform: capitalize; margin-top: 5px">
                  {{ date | customDate : 'date' }}
                </p>
              </div>

              <div class="d-flex align-items-start gap-3">
                <span class="fs-5">
                  <img src="assets/img/emojis/clock.svg" alt="clock emoji" loading="lazy" width="20" />
                </span>
                <p class="mb-0 text-dark" style="margin-top: 5px">
                  {{ date | customDate : 'time' }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-start gap-3" *ngFor="let place of places">
              <span class="fs-5">
                <img src="assets/img/emojis/location.svg" alt="map emoji" loading="lazy" width="20" />
              </span>
              <p class="mb-0 text-dark" style="margin-top: 5px">{{ place }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Order Details Card -->
    <div class="card card-solid bg-white mb-4">
      <div class="card-body p-4 d-flex flex-column gap-3">
        <!-- Header with Logo -->
        <div class="d-flex align-items-center gap-3">
          <div class="tix-logo">
            <img src="assets/img/logo-tix.png" alt="" width="54" />
          </div>
          <div>
            <h3 class="h6 mb-0 text-dark">TIX-{{ order?.id ?? '' }}</h3>
            <p class="small text-muted mb-0">{{ totalTicketsCount }} tickets</p>
          </div>
        </div>

        <!-- Tickets List -->
        <div class="">
          <ng-container *ngFor="let ticketType of parsedTicketsData; let i = index">
            <div class="d-flex justify-content-between align-items-start">
              <div class="flex-fill">
                <p class="mb-1 text-dark">
                  {{ ticketType.ticketTypeName
                  }}<span class="text-muted small">
                    x {{ ticketType.qty }}</span>
                </p>
                <div class="d-flex align-items-center gap-2 mb-1">
                  <span class="text-muted small">{{
                    order?.free_event ? '' : 'RD$' + (ticketType.price | number)
                    }}</span>
                </div>
                <div class="d-flex align-items-center" *ngIf="ticketType.isSeat">
                  <span class="text-black small">Asientos: {{ ticketType.ticketsLabel.join(', ') }}</span>
                </div>
              </div>
              <p class="mb-0 text-dark">
                RD${{ ticketType.qty * ticketType.price | number }}
              </p>
            </div>
            <hr class="my-3" *ngIf="i < parsedTicketsData.length - 1" />
          </ng-container>
        </div>

        <hr class="my-4" />

        <!-- Price Breakdown -->
        <div class="d-flex flex-column gap-2">
          <div class="d-flex justify-content-between">
            <span class="text-muted">Subtotal</span>
            <span class="text-dark">RD${{ order?.subTotal | number }}</span>
          </div>
          <div class="d-flex justify-content-between">
            <span class="text-muted">Cargo por Servicio</span>
            <span class="text-dark">RD${{ order?.serviceFee | number }}</span>
          </div>
          <div class="d-flex justify-content-between">
            <span class="text-muted">Seguro</span>
            <span class="text-dark">RD${{ order?.insuranceFee | number }}</span>
          </div>
          <div class="d-flex justify-content-between" *ngIf="hasCoupons()">
            <span style="color: #28a745">
              {{ getCouponsCount() > 1 ? 'Códigos' : 'Código' }} de Descuento
              ({{ allCouponsNames }})
            </span>
            <span style="color: #28a745">
              <span class="text-nowrap">-RD$</span>{{ order?.discounted | number }}
            </span>
          </div>

          <hr class="my-2" />

          <div class="d-flex justify-content-between align-items-center">
            <span class="fw-bold text-dark">Total Pagado</span>
            <span class="fw-bold text-dark">RD${{ order?.totalToPay | number }}</span>
          </div>
        </div>

        <!-- Payment Info -->
        <div class="bg-light rounded-3 p-3 d-flex flex-column gap-2 mt-4">
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-muted small">Nombre</span>
            <span class="text-dark small">{{ order?.buyerName }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-muted small">Email</span>
            <span class="text-dark small">{{ order?.buyerEmail }}</span>
          </div>
          <ng-container *ngIf="order?.totalToPay && order!.totalToPay > 0">
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-muted small">Método de Pago</span>
              <div class="d-flex align-items-center gap-2">
                <img [src]="cardLogo" alt="card type" style="width: 36px; height: 22px; object-fit: contain" />
                <span class="text-dark small">{{
                  extractCardSuffix(order?.creditCard ?? '')
                  }}</span>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-muted small">Autorización</span>
              <span class="text-dark small">{{ order?.authorization }}</span>
            </div>
          </ng-container>

          <hr class="my-2" />

          <div class="text-center">
            <span class="text-dark small" style="text-transform: capitalize">{{
              order?.createdAt | customDate
              }}</span>
          </div>
        </div>
      </div>

      <!-- Back to Home (tix.do) -->
      <!--<a class="back-home-btn w-100 rounded-pill d-flex align-items-center justify-content-center gap-2 text-decoration-none"
        [target]="'_blank'" routerLink="/" [class.disabled]="!order?.slug"
        style="padding: 6px 0px; background-color: #ffffff">
        <span style="height: 18px; display: flex; align-items: center"><img src="assets/icons/back-icon.svg"
            alt="back icon" loading="lazy" width="26" />
        </span>
        <span class="fw-medium">Volver al inicio</span>
      </a>-->
    </div>

    <!-- Back to Home (tix.do) -->
    <a class="w-100 rounded-pill d-flex align-items-center justify-content-center gap-2 text-decoration-none text-dark mb-4"
      [target]="'_blank'" routerLink="/" [class.disabled]="!order?.slug" style="padding: 6px 0px;">
      <span>Volver a tix.do</span>
    </a>

    <!-- Footer -->
    <p class="text-center text-muted small mb-0">
      Creado con mucho 🖤 desde TIX
    </p>
  </div>
</main>